// extracted by mini-css-extract-plugin
export default {"contato_container":"Contact_contato_container__T19yt","btn":"Contact_btn__mdPwa","form":"Contact_form__Mmq9k","form_group":"Contact_form_group__YOI2d"};